const GraphSettingsThresholdsSet = (dataViewType) => {

  let ret

  switch (dataViewType) {
    case 'graph_soil_profile_probe_moisture':
    case 'graph_sdi12_moisture_rootzone_average_plus_discrete_lower':
    case 'graph_sdi12_moisture_average':
      ret = {
        unitKey: 'percent',
        unit: '%',
        thresholds: [{
          label: 'Full Point',
          key: 'full_point',
        },{
          label: 'Refill Point',
          key: 'refill_point',
        },{
          label: 'Stress Point',
          key: 'stress_point',
        }]
      }
      break
    case 'graph_sdi12_moisture_sum':
      ret = {
        unitKey: 'moisture_units',
        unit: 'MU',
        thresholds: [{
          label: 'Full Point',
          key: 'full_point',
        },{
          label: 'Refill Point',
          key: 'refill_point',
        },{
          label: 'Stress Point',
          key: 'stress_point',
        }]
      }
      break
    case 'graph_tension':
      ret = {
        unitKey: 'kpa',
        unit: 'kPa',
        thresholds: [{
          label: 'Full Point',
          key: 'full_point',
        },{
          label: 'Refill Point',
          key: 'refill_point',
        },{
          label: 'Stress Point',
          key: 'stress_point',
        }]
      }
      break
  }

  return ret

}

export default GraphSettingsThresholdsSet



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphSettingsThresholdsSet.js